module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    attrs: {
      "epub:type": "dedication",
      "role": "doc-dedication"
    }
  }, [_c('p', {
    staticClass: "ded1"
  }, [_c('span', {
    attrs: {
      "aria-label": "page 5",
      "epub:type": "pagebreak",
      "id": "page_5",
      "role": "doc-pagebreak"
    }
  }, [_c('i', [_vm._v("To all of my teachers:your knowledge and embodied wisdom are the backbone of this book.")])])]), _vm._v(" "), _c('p', {
    staticClass: "ded2"
  }, [_vm._v("~")]), _vm._v(" "), _c('p', {
    staticClass: "ded3"
  }, [_c('i', [_vm._v("To that place within each of us that knows the way home.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2e2e5954","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/e9781646040964/xhtml/dedication.vue
// module id = 63
// module chunks = 0